import React from "react";
import Modal from "../ui/Modal";
import { CheckCircle, XCircle, AlertTriangle, Info } from "lucide-react";

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: "success" | "error" | "warning" | "info";
  buttonText?: string;
}

export default function AlertModal({ isOpen, onClose, title, message, type = "info", buttonText = "Tamam" }: AlertModalProps) {
  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle className="w-6 h-6 text-green-600" />;
      case "error":
        return <XCircle className="w-6 h-6 text-red-600" />;
      case "warning":
        return <AlertTriangle className="w-6 h-6 text-yellow-600" />;
      case "info":
      default:
        return <Info className="w-6 h-6 text-blue-600" />;
    }
  };

  const getButtonClasses = () => {
    const baseClasses = "px-4 py-2 rounded-md font-medium text-sm text-white";

    switch (type) {
      case "success":
        return `${baseClasses} bg-green-600 hover:bg-green-700`;
      case "error":
        return `${baseClasses} bg-red-600 hover:bg-red-700`;
      case "warning":
        return `${baseClasses} bg-yellow-600 hover:bg-yellow-700`;
      case "info":
      default:
        return `${baseClasses} bg-blue-600 hover:bg-blue-700`;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">{getIcon()}</div>
          <p className="text-gray-700 flex-1 whitespace-pre-line">{message}</p>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-200">
          <button onClick={onClose} className={getButtonClasses()}>
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
